import { render, staticRenderFns } from "./TypeMovie.vue?vue&type=template&id=47d4f254&"
import script from "./TypeMovie.vue?vue&type=script&lang=js&"
export * from "./TypeMovie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports